import { on, createReducer } from '@ngrx/store';
import {
  searchInstitutions,
  searchInstitutionsSuccess,
  setFilterInput,
  setSearchTerm,
  updateFilterInput
} from './institutions.actions';
import { StoreState } from '../../enums/store-state';
import { Institution, SortByEnum } from 'src/generated/graphql';
import { InstitutionsFilter } from 'src/app/core/models/institutions-filter';
import { PAGING_CONFIG } from 'src/app/features/institution/instution.constant';

export const institutionsFeatureKey = 'institutionsFeatureKey';

export interface InstitutionsState {
  institutionsState: StoreState;
  institutions: Institution[];
  total: number;
  filterInput: InstitutionsFilter;
  searchTerm: string;
}

export const initialState: InstitutionsState = {
  institutionsState: StoreState.idle,
  institutions: [],
  total: 0,
  filterInput: {
    pagination: {
      limit: PAGING_CONFIG.config.itemsPerPage,
      offset: 0
    },
    sortBy: SortByEnum.NameAsc
  },
  searchTerm: ''
};

export const institutionsReducer = createReducer(
  initialState,

  on(searchInstitutions, (state) => ({
    ...state,
    institutionsState: StoreState.inProgress,
    institutions: []
  })),
  on(searchInstitutionsSuccess, (state, data) => ({
    ...state,
    institutionsState: StoreState.success,
    institutions: data.institutions,
    total: data.total
  })),
  on(setFilterInput, (state, data) => ({
    ...state,
    institutionsState: StoreState.inProgress,
    filterInput: data.filterInput
  })),
  on(updateFilterInput, (state, data) => ({
    ...state,
    institutionsState: StoreState.inProgress,
    filterInput: {
      ...state.filterInput,
      ...data.filterInput
    }
  })),
  on(setSearchTerm, (state, data) => ({
    ...state,
    searchTerm: data.searchTerm
  }))
);
